import React from "react";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <Container className="py-5 text-center" style={{ minHeight: "55vh" }}>
      <div className="display-1 fw-bold" style={{ color: "var(--brand)" }}>404</div>
      <h1 className="h3 mb-2">Page Not Found</h1>
      <p className="text-muted-2 mb-4">
        The page or post you're looking for doesn't exist or may have been moved.
      </p>
      <Button as={Link} to="/" className="btn-brand px-4">Back to Home</Button>
    </Container>
  );
}

export default NotFound;
